export const TIPO_PESSOA_SELECIONAR = "TIPO_CADASTRO_TIPO_PESSOA_SELECIONAR";
export const TIPO_NECESSIDADE_SELECIONAR = "TIPO_NECESSIDADE_SELECIONAR";
export const TIPO_PRODUTO_SELECIONAR = "TIPO_CADASTRO_TIPO_PRODUTO_SELECIONAR";
export const SET_TIPO_CONTRATO = "SET_TIPO_CONTRATO";
export const SET_TIPO_PRODUTO = "SET_TIPO_PRODUTO";
export const LOADING_TIPO_PRODUTO = "LOADING_TIPO_PRODUTO";
export const ERROR_TIPO_PRODUTO = "ERROR_TIPO_PRODUTO";
export const VALUE_TIPO_PRODUTO = "VALUE_TIPO_PRODUTO";
export const SET_LOGO_PARCEIRO = "SET_LOGO_PARCEIRO";
